import { API } from "../api/axios";
const END_POINT = "/canteen";

class CantinesService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
    update(data) {
        return API.post(`${END_POINT}`, data);
    }
}

export default new CantinesService();
